module.exports = __webpack_public_path__ + "img/re71rs.b876d65d.webp";